// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".banner-text-primary {\n  height: 60px;\n  color: var(--primary);\n  overflow: auto;\n  font-family: Catamaran;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 24px;\n  line-height: 39px;\n  display: flex;\n  align-items: flex-end; }\n", ""]);
// Exports
module.exports = exports;
